
(function () {
  if (window.__ajInit) return; window.__ajInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // VHS の時刻表示
  var tc = document.getElementById('tc');
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // トップの映像：data-clips の順に流し、1本終わったら次へ。PC は3枠、スマホは1枠
  // 各部品が無いページでも動くようにする（Shopify では部品ごとに別ページに置く）
  var stage = document.getElementById('heroStage');
  var clips = !stage ? [] : stage.getAttribute('data-clips').split(',').map(function (s) {
    var p = s.trim().split(/\s+/); return { src: p[0], poster: p[1] };
  });
  var slots = stage ? Array.prototype.slice.call(stage.querySelectorAll('video')) : [];
  var wide = window.matchMedia('(min-width: 900px)');
  var nextClip = 0;
  var heroVisible = true;
  function activeSlots() { return wide.matches ? slots : slots.slice(0, 1); }
  function mainSlot() { return wide.matches ? slots[1] : slots[0]; }   // 音と時刻表示の対象
  function play(v) { if (reduce || !heroVisible) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function load(v) {
    var act = activeSlots(), c;
    for (var k = 0; k < clips.length; k++) {   // ほかの枠で流れている映像は飛ばす
      c = clips[nextClip++ % clips.length];
      if (!act.some(function (o) { return o !== v && o.dataset.cur === c.src; })) break;
    }
    v.classList.remove('on');
    v.dataset.cur = c.src;
    v.poster = c.poster;
    v.src = c.src;
    if (reduce) v.classList.add('on'); else play(v);
  }
  slots.forEach(function (v) {
    v.addEventListener('playing', function () { v.classList.add('on'); });
    v.addEventListener('timeupdate', function () {
      if (v.duration && v.duration - v.currentTime < .6) v.classList.remove('on');   // 終わり際に暗転
      if (v === mainSlot()) {
        var s = Math.floor(v.currentTime);
        tc.textContent = 'SP 0:' + pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      }
    });
    v.addEventListener('ended', function () { load(v); });
  });
  activeSlots().forEach(load);
  function onWide() {
    slots.forEach(function (v) { v.muted = true; });   // 音の対象の枠が変わるので一度消す
    setBtn(heroSnd, false);
    slots.slice(1).forEach(function (v) {
      if (wide.matches) { if (!v.dataset.cur) load(v); else play(v); }
      else { v.pause(); v.muted = true; }
    });
  }
  if (wide.addEventListener) wide.addEventListener('change', onWide); else wide.addListener(onWide);

  // 音：同時に鳴らすのは1本だけ。ブラウザの制限で、最初はタップされるまで無音
  var heroSnd = document.getElementById('heroSnd');
  var reels = Array.prototype.slice.call(document.querySelectorAll('.reel'));
  function setBtn(b, on) {
    if (!b) return;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? '音を消す' : '音を出す');
    var l = b.querySelector('.lbl'); if (l) l.textContent = on ? 'Sound on' : 'Sound off';
  }
  function muteAll(except) {
    slots.forEach(function (v) { if (v !== except) v.muted = true; });
    if (slots.indexOf(except) < 0) setBtn(heroSnd, false);
    reels.forEach(function (r) {
      var v = r.querySelector('video');
      if (v !== except) { v.muted = true; setBtn(r.querySelector('.snd'), false); }
    });
  }
  function toggle(v, b) {
    var on = v.muted;
    muteAll(v);
    v.muted = !on;
    setBtn(b, on);
    if (on) { if (!v.src && v.dataset.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  if (heroSnd) heroSnd.addEventListener('click', function () { toggle(mainSlot(), heroSnd); });
  reels.forEach(function (r) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'snd';
    b.innerHTML = '<span class="eq" aria-hidden="true"><i></i><i></i><i></i><i></i></span><span class="lbl">Sound off</span>';
    setBtn(b, false);
    r.appendChild(b);
    r.addEventListener('click', function () { toggle(r.querySelector('video'), b); });
  });

  // 2026 ルックの送りボタン
  var rail = document.getElementById('rail');
  function step(dir) {
    var card = rail.querySelector('.look');
    var w = card ? card.getBoundingClientRect().width + 4 : 300;
    rail.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
  }
  if (rail) {
    document.getElementById('railPrev').addEventListener('click', function () { step(-1); });
    document.getElementById('railNext').addEventListener('click', function () { step(1); });
  }

  if (!('IntersectionObserver' in window)) return;

  // 写真が画面に入ったらストロボを一度だけ光らせる
  if (!reduce) {
    var fo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('flash'); fo.unobserve(e.target); }
      });
    }, { threshold: .35 });
    document.querySelectorAll('.night-grid .shot, .motif-grid .shot, .posters .shot').forEach(function (el) { fo.observe(el); });
  }

  // 映像は見えている間だけ再生する
  var vo = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else {
        v.pause();
        if (!v.muted) { v.muted = true; setBtn(v.parentNode.querySelector('.snd'), false); }
      }
    });
  }, { threshold: .25 });
  document.querySelectorAll('.reel video').forEach(function (v) { vo.observe(v); });

  // トップの映像は画面から外れたら止めて音も消し、戻ったら再開する
  if (stage) new IntersectionObserver(function (es) {
    heroVisible = es[0].isIntersecting;
    activeSlots().forEach(function (v) {
      if (heroVisible) play(v);
      else { v.pause(); v.muted = true; }
    });
    if (!heroVisible) setBtn(heroSnd, false);
  }, { threshold: .1 }).observe(stage);
})();
